import {forwardRef} from 'react';
import BaseInputGroup from '../../sisu/form/BaseInputGroup.sisu';

const NeoInputGroup = forwardRef((props, ref) => {
  return <BaseInputGroup {...props} ref={ref} />;
});

export default NeoInputGroup;
